import React, { useEffect, useRef, useState } from "react";
import { Spinner, Text, Link, HiddenVisually } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import List from "./List.js";
export default function Results(props) {
    const { add, addMulti, error, i18n, enableMultiSelect, loading, remove, result, selected, success, disableIndent, showAnywhere } = props;
    const [announceNoResults, setAnnounceNoResults] = useState(false);
    const timerRef = useRef();
    useEffect(() => {
        clearTimeout(timerRef.current);
        if (success && !result.length) {
            timerRef.current = setTimeout(() => {
                setAnnounceNoResults(true);
            }, 1500);
        }
        else {
            setAnnounceNoResults(false);
        }
    }, [success, result.length]);
    if (error)
        return (React.createElement(Text, { variant: "body_2" },
            i18n.trans(t("flights_error_unknown_header")),
            ". ",
            React.createElement(Link, { href: "/" }, i18n.trans(t("flights_error_timeout_subheader")))));
    if (loading)
        return (React.createElement(React.Fragment, null,
            React.createElement(HiddenVisually, null,
                React.createElement("div", { role: "alert" }, i18n.trans(t("a11y_flights_searchbox_origin_destination_loading_state")))),
            React.createElement(Spinner, null)));
    if (success && result.length)
        return (React.createElement(List, { add: add, addMulti: addMulti, enableMultiSelect: enableMultiSelect, i18n: i18n, list: result, remove: remove, selected: selected, disableIndent: disableIndent, showAnywhere: showAnywhere }));
    if (success && !result.length)
        return (React.createElement(React.Fragment, null,
            announceNoResults && (React.createElement(HiddenVisually, null,
                React.createElement("div", { "aria-live": "assertive", role: "alert" }, i18n.trans(t("flights_search_no_location_found"))))),
            React.createElement(Text, { variant: "body_2" }, i18n.trans(t("flights_search_no_location_found")))));
    return enableMultiSelect ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { color: "neutral_alt", variant: "body_2" }, showAnywhere
            ? i18n.trans(t("flights_sb_usp_explore_subtext"))
            : i18n.trans(t("flights_sb_usp_multi_search_subtext"))))) : null;
}
